import { WorkshopStatus, EnrollmentStatus, WorkshopPaymentStatus, PaymentSource } from "../../models/workshops";

export const workshopStatusOptions = [
  { label: "Borrador", value: "draft" },
  { label: "Activo", value: "active" },
  { label: "Pausado", value: "paused" },
  { label: "Finalizado", value: "finished" },
];

export const getWorkshopStatusLabel = (status: WorkshopStatus): string => {
  const map: Record<WorkshopStatus, string> = {
    draft: "Borrador",
    active: "Activo",
    paused: "Pausado",
    finished: "Finalizado",
  };
  return map[status] || status;
};

export const getWorkshopStatusSeverity = (status: WorkshopStatus): "info" | "success" | "warning" | "danger" | undefined => {
  const map: Record<WorkshopStatus, "info" | "success" | "warning" | "danger"> = {
    draft: "info",
    active: "success",
    paused: "warning",
    finished: "danger",
  };
  return map[status];
};

export const getEnrollmentStatusLabel = (status: EnrollmentStatus): string => {
  const map: Record<EnrollmentStatus, string> = {
    active: "Activo",
    pending_payment: "Pago pendiente",
    dropped_attendance: "Baja por inasistencia",
    dropped_manual: "Baja manual",
  };
  return map[status] || status;
};

export const getEnrollmentStatusSeverity = (status: EnrollmentStatus): "info" | "success" | "warning" | "danger" | undefined => {
  const map: Record<EnrollmentStatus, "success" | "warning" | "danger"> = {
    active: "success",
    pending_payment: "warning",
    dropped_attendance: "danger",
    dropped_manual: "danger",
  };
  return map[status];
};

export const getPaymentStatusLabel = (status: WorkshopPaymentStatus): string => {
  const map: Record<WorkshopPaymentStatus, string> = {
    pending: "Pendiente",
    approved: "Aprobado",
    rejected: "Rechazado",
    refunded: "Reembolsado",
  };
  return map[status] || status;
};

export const getPaymentSourceLabel = (source: PaymentSource): string => {
  const map: Record<PaymentSource, string> = {
    MERCADO_PAGO: "MercadoPago",
    OFFLINE: "Efectivo",
  };
  return map[source] || source;
};
